import { useTheme } from "../styles/theme";

export default function LoadingScreen() {
  const S = useTheme();
  return (
    <div
      style={{
        ...S.root,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <div style={{ color: S.colors.textFaint, fontSize: 16 }}>Loading...</div>
    </div>
  );
}
